export class Cess{
    refNo:number;
    cessRate:number;
}